export default __webpack_public_path__ + "static/tempoteam-4a7fcc73178e5bf8961447e68bd5f865.png";